var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMistralLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e7e7e7;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M666.97,40.5h-86.34v143.8h-148.12v143.8h-72.28v-143.8h-142.2V40.5H0v719h218.03v-287.6h72.28v143.8h218.03v-143.8h72.28v287.6h219.37V40.5h-133.03ZM11.85,747.66V52.34h62.21v695.33H11.85ZM302.17,603.86v-131.96h62.21v131.96h-62.21ZM444.36,328.1v-131.96h69.47v131.96h-69.47ZM592.48,52.34h63.54v131.96h-63.54V52.34ZM592.48,747.66v-275.76h63.54v275.76h-63.54Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMistralLogo);
export default __webpack_public_path__ + "static/media/MistralLogo.ac024f6cdf6f56b381282c71eb066dd7.svg";
export { ForwardRef as ReactComponent };